import { rizaBlogu } from "./kvkk.js";
import { yapabilir } from "../domain/auth.js";
import { SIDDET, acilDurum, alabilecekler, alamayanlar, alerjiler, hayatiRisk, saglik, teslimKisiti, veliler } from "../domain/students.js";
import { ATT, PAY, classChip } from "./ui.js";
import { DONEM } from "../config.js";
import { B, cls, stu } from "../domain/context.js";
import { age, donemAdi, esc, fmtDate, money } from "../lib/fmt.js";
import { bindPhotoEvents } from "../bindings/photo.js";
import { faturaDurumu, faturaTutari, hesapOzeti, payOf, tahsilEdilen } from "../domain/invoices.js";
import { feeFor } from "../domain/fees.js";
import { photoBlock, photoControls } from "../lib/photo.js";

// ---------- ÖĞRENCİ MODALI ----------
export function openStudentModal(id) {
  const s = stu(id);
  if (!s) return;
  const c = cls(s.classId);
  const a = B().attendance[s.id];
  const pay = payOf(s.id);
  const fee = feeFor(s, pay);
  const hesap = hesapOzeti(s);
  const rep = B().dailyReports.find(r => r.studentId === s.id);

  document.getElementById("modalBox").innerHTML = `
    <div class="h-2.5 rounded-t-2xl" style="background:${c.color}"></div>
    <div class="p-6">
      <div class="flex items-start gap-4">
        ${photoBlock(s, "student", c.color, "w-14 h-14")}
        <div class="flex-1 min-w-0">
          <h2 class="font-display font-bold text-xl">${esc(s.name)}</h2>
          <div class="flex items-center gap-2 mt-1 flex-wrap">
            ${classChip(s.classId)}
            <span class="text-xs text-inksoft">${age(s.birthDate)} · ${fmtDate(s.birthDate)} doğumlu</span>
          </div>
        </div>
        <button id="modalClose" class="p-1.5 rounded-lg hover:bg-paper" aria-label="Kapat">
          <svg class="w-5 h-5" fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24"><path stroke-linecap="round" d="M6 18L18 6M6 6l12 12"/></svg>
        </button>
      </div>
      ${photoControls(s, "student")}

      <div class="grid grid-cols-2 gap-3 mt-5 text-sm">
        <div class="rounded-xl bg-paper p-3">
          <div class="text-[11px] font-bold text-inksoft uppercase">Bugün</div>
          <div class="font-semibold mt-0.5">${ATT[a.status].label}${a.in ? ` · ${a.in}` : ""}</div>
          ${a.reason ? `<div class="text-[11px] text-inksoft">${esc(a.reason)}</div>` : ""}
        </div>
        <div class="rounded-xl bg-paper p-3">
          <div class="text-[11px] font-bold text-inksoft uppercase">Devam</div>
          <div class="font-semibold mt-0.5">${s.schedule === "yarim" ? "Yarım gün" : "Tam gün"}</div>
          <div class="text-[11px] text-inksoft">${esc(c.name)} · ${esc(c.age)}</div>
        </div>
        <div class="rounded-xl bg-paper p-3 col-span-2">
          <div class="flex items-center justify-between">
            <span class="text-[11px] font-bold text-inksoft uppercase">Aylık Ücret · ${donemAdi(DONEM)}</span>
            ${pay ? `<span class="text-[10px] font-bold rounded-full px-2 py-0.5 ${PAY[faturaDurumu(s, pay)].chip}">${PAY[faturaDurumu(s, pay)].label}</span>` : ""}
          </div>
          <div class="mt-1.5 space-y-0.5 text-[12px]">
            <div class="flex justify-between gap-3"><span class="text-inksoft">${fee.half ? "Yarım gün" : "Tam gün"} · ${esc(c.name)}</span><span class="shrink-0">${money(fee.base)}</span></div>
            ${fee.service ? `<div class="flex justify-between gap-3"><span class="text-inksoft">Servis</span><span class="shrink-0">${money(fee.service)}</span></div>` : ""}
            ${fee.discount ? `<div class="flex justify-between gap-3 text-teal"><span>${esc(fee.discountLabel)} (%${fee.pct})</span><span class="shrink-0">− ${money(fee.discount)}</span></div>` : ""}
            ${fee.override !== null ? `<div class="flex justify-between gap-3 text-grape"><span>Özel tutar (${esc(pay.note ?? "istisna")})</span><span class="shrink-0">${money(fee.override)}</span></div>` : ""}
          </div>
          <div class="flex justify-between font-display font-bold text-base mt-2 pt-2 border-t border-line">
            <span>Toplam</span><span>${money(fee.total)}</span>
          </div>
        </div>

        <div class="rounded-xl bg-paper p-3 col-span-2">
          <div class="text-[11px] font-bold text-inksoft uppercase">Cari Hesap</div>
          <div class="grid grid-cols-3 gap-2 mt-2 text-center">
            <div>
              <div class="font-display font-bold text-sm">${money(hesap.tahakkuk)}</div>
              <div class="text-[10px] text-inksoft">Tahakkuk</div>
            </div>
            <div>
              <div class="font-display font-bold text-sm text-teal">${money(hesap.tahsil)}</div>
              <div class="text-[10px] text-inksoft">Tahsil</div>
            </div>
            <div>
              <div class="font-display font-bold text-sm ${hesap.kalan > 0 ? "text-coral" : "text-inksoft"}">${money(hesap.kalan)}</div>
              <div class="text-[10px] text-inksoft">Bakiye</div>
            </div>
          </div>
        </div>

        <div class="rounded-xl bg-paper p-3 col-span-2">
          <div class="flex items-center justify-between">
            <span class="text-[11px] font-bold text-inksoft uppercase">Fatura & Ödeme Geçmişi</span>
            <span class="text-[10px] text-inksoft">${hesap.faturalar.length} dönem</span>
          </div>
          <div class="mt-2 space-y-1.5 max-h-72 overflow-y-auto pr-1">
            ${hesap.faturalar.map(inv => {
              const tutar = faturaTutari(s, inv);
              const durum = faturaDurumu(s, inv);
              const odenen = tahsilEdilen(inv);
              return `
              <div class="rounded-lg bg-white px-2.5 py-2">
                <div class="flex items-center justify-between gap-2">
                  <span class="text-xs font-semibold">${donemAdi(inv.period)}</span>
                  <span class="flex items-center gap-2 shrink-0">
                    <span class="text-xs font-semibold">${money(tutar)}</span>
                    <span class="text-[9px] font-bold rounded-full px-1.5 py-0.5 ${PAY[durum].chip}">${PAY[durum].label}</span>
                  </span>
                </div>
                ${inv.transactions.map(h => `
                  <div class="flex items-center justify-between gap-2 text-[10px] text-inksoft mt-1">
                    <span class="truncate">${fmtDate(h.date)} · ${esc(h.method)} · ${esc(h.receiptNo)}</span>
                    <span class="shrink-0 text-teal font-semibold">${money(h.amount)}</span>
                  </div>`).join("")}
                ${durum !== "odendi" ? `
                  <div class="flex items-center justify-between gap-2 text-[10px] mt-1">
                    <span class="text-inksoft">Vade ${fmtDate(inv.due)}${inv.note ? ` · ${esc(inv.note)}` : ""}</span>
                    <span class="shrink-0 font-semibold text-coral">${money(tutar - odenen)} açık</span>
                  </div>` : inv.note ? `<div class="text-[10px] text-inksoft mt-1">${esc(inv.note)}</div>` : ""}
              </div>`;
            }).join("")}
          </div>
        </div>
        <div class="rounded-xl bg-paper p-3 col-span-2">
          <div class="text-[11px] font-bold text-inksoft uppercase">Veliler</div>
          ${veliler(s).map(v => `
            <div class="flex items-center gap-2 mt-0.5">
              <span class="font-semibold">${esc(v.name)}</span>
              <span class="text-[11px] text-inksoft">${esc(v.relation)} · ${esc(v.phone)}</span>
              ${v.canPickup === false
                ? `<span class="text-[10px] font-bold rounded-full bg-coral text-white px-1.5 py-0.5 shrink-0">Teslim alamaz</span>`
                : ""}
            </div>`).join("")}
          <div class="text-[11px] text-inksoft mt-1">Kayıt tarihi: ${fmtDate(s.enrolledAt)} ${s.service ? "· 🚌 Servis kullanıyor" : ""}</div>
          ${veliErisimBlogu(s)}
        </div>

        ${teslimYetkisiBlogu(s)}
        ${saglikBlogu(s)}
        ${rizaBlogu(s)}
        ${veriHaklariBlogu(s)}
        ${rep ? `
        <div class="rounded-xl bg-teal-soft p-3 col-span-2">
          <div class="text-[11px] font-bold text-teal uppercase">Bugünkü Rapor</div>
          <div class="text-xs mt-1">🥐 ${esc(rep.meals.kahvalti)} · 🍲 ${esc(rep.meals.ogle)} · 😴 ${esc(rep.sleep)} · Ruh hali: ${esc(rep.mood)}</div>
        </div>` : ""}
      </div>
    </div>`;

  const modal = document.getElementById("modal");
  modal.classList.remove("hidden");
  modal.classList.add("flex");
  document.getElementById("modalClose").onclick = closeModal;
  bindPhotoEvents(document.getElementById("modalBox"));
}

// ---------- Kimler alabilir (§3) ----------
// Kapıdaki personelin tek bakışta göreceği blok. Kısıt varsa en üstte
// ve kırmızı: bir çocuğun yetkisiz kişiye teslimi geri alınamaz.
function teslimYetkisiBlogu(s) {
  const kisit = teslimKisiti(s);
  const alabilir = alabilecekler(s);
  const alamaz = alamayanlar(s);
  const acil = acilDurum(s);

  return `
  <div class="rounded-xl border-2 ${kisit ? "border-coral bg-coral-soft" : "border-line bg-paper"} p-3 col-span-2">
    <div class="flex items-center gap-2">
      <span class="text-[11px] font-bold uppercase ${kisit ? "text-coral" : "text-inksoft"}">Çocuğu kimler alabilir</span>
      ${kisit ? `<span class="text-[10px] font-bold rounded-full bg-coral text-white px-2 py-0.5">KISIT VAR</span>` : ""}
    </div>

    ${kisit ? `<p class="text-xs font-semibold text-coral mt-1.5 leading-snug">${esc(kisit)}</p>` : ""}

    <ul class="mt-2 space-y-1">
      ${alabilir.map(k => `
        <li class="flex items-center gap-2 text-xs">
          <span class="text-teal shrink-0">✓</span>
          <span class="font-semibold">${esc(k.name)}</span>
          <span class="text-inksoft truncate">${esc(k.relation)}${k.idLast4 ? ` · kimlik ****${esc(k.idLast4)}` : ""} · ${esc(k.phone)}</span>
        </li>
        ${k.note ? `<li class="text-[10px] text-inksoft pl-5 -mt-0.5">${esc(k.note)}</li>` : ""}`).join("")}

      ${alamaz.map(k => `
        <li class="flex items-center gap-2 text-xs">
          <span class="text-coral shrink-0">✕</span>
          <span class="font-semibold line-through">${esc(k.name)}</span>
          <span class="text-coral truncate">${esc(k.relation)} — teslim edilmez</span>
        </li>`).join("")}
    </ul>

    <div class="text-[11px] text-inksoft mt-2 pt-2 border-t border-line/70">
      Acil durumda: <span class="font-semibold text-ink">${esc(acil.name)}</span>
      (${esc(acil.relation)}) · ${esc(acil.phone)}
    </div>
  </div>`;
}

// ---------- Sağlık (§3) ----------
function saglikBlogu(s) {
  const alerji = alerjiler(s);
  const tibbi = saglik(s);
  const kritik = hayatiRisk(s);
  if (!alerji.length && !tibbi?.conditions?.length && !s.note) return "";

  return `
  <div class="rounded-xl ${kritik ? "border-2 border-coral" : ""} bg-coral-soft p-3 col-span-2">
    <div class="flex items-center gap-2">
      <span class="text-[11px] font-bold text-coral uppercase">Sağlık</span>
      ${kritik ? `<span class="text-[10px] font-bold rounded-full bg-coral text-white px-2 py-0.5">HAYATİ RİSK</span>` : ""}
    </div>

    ${alerji.map(a => `
      <div class="mt-1.5">
        <div class="flex items-center gap-2">
          <span class="font-semibold text-coral">⚠ ${esc(a.name)}</span>
          <span class="text-[10px] font-bold rounded-full bg-${SIDDET[a.severity].renk} text-white px-1.5 py-0.5">${SIDDET[a.severity].label}</span>
        </div>
        <div class="text-xs mt-0.5 leading-snug">${esc(a.response)}</div>
      </div>`).join("")}

    ${tibbi ? `
      <dl class="grid grid-cols-2 gap-x-3 gap-y-1 text-[11px] mt-2 pt-2 border-t border-coral/20">
        ${tibbi.bloodType ? `<div><dt class="text-inksoft inline">Kan grubu:</dt> <dd class="font-semibold inline">${esc(tibbi.bloodType)}</dd></div>` : ""}
        ${tibbi.insurance ? `<div><dt class="text-inksoft inline">Sigorta:</dt> <dd class="inline">${esc(tibbi.insurance)}</dd></div>` : ""}
        ${tibbi.doctor ? `<div class="col-span-2"><dt class="text-inksoft inline">Hekim:</dt> <dd class="inline">${esc(tibbi.doctor.name)} · ${esc(tibbi.doctor.phone)}</dd></div>` : ""}
        ${tibbi.conditions?.length ? `<div class="col-span-2"><dt class="text-inksoft inline">Tanı:</dt> <dd class="font-semibold inline">${tibbi.conditions.map(esc).join(", ")}</dd></div>` : ""}
      </dl>
      ${tibbi.note ? `<div class="text-xs mt-1.5 font-semibold">${esc(tibbi.note)}</div>` : ""}` : ""}

    ${s.note ? `<div class="text-xs mt-2 pt-2 border-t border-coral/20">${esc(s.note)}</div>` : ""}
  </div>`;
}

// ---------- Veri sahibi hakları (§9) ----------
function veriHaklariBlogu(s) {
  if (!yapabilir("ogrenciDuzenle")) return "";
  return `
  <div class="rounded-xl bg-paper p-3 col-span-2">
    <div class="text-[11px] font-bold text-inksoft uppercase">Veri Sahibi Hakları</div>
    <p class="text-[11px] text-inksoft mt-1">
      Veli, çocuğuna ait tüm veriyi makine okunur biçimde alma hakkına sahiptir.
    </p>
    <button data-export="${s.id}"
      class="mt-2 rounded-lg border border-line bg-white text-[11px] font-semibold px-3 py-1.5 hover:bg-paper">
      Veri dökümünü indir (JSON)
    </button>
  </div>`;
}

/**
 * Velinin uygulamaya erişimi.
 *
 * Tohum veride veliler için yalnızca telefon vardı; Google/Apple ile
 * giriş ise E-POSTA üzerinden eşleşiyor. Bu alan olmadan bir kreş
 * velisini uygulamaya hiç davet edemiyordu.
 *
 * Davet çocuğa bağlı: children listesi bu öğrencinin kimliğini
 * taşıyor, yani veli yalnızca kendi çocuğunu görüyor.
 */
function veliErisimBlogu(s) {
  if (!yapabilir("ogrenciDuzenle")) return "";

  const eposta = s.parentEmail ?? "";
  return `
    <div class="mt-3 pt-3 border-t border-line/70">
      <div class="text-[11px] font-bold text-inksoft uppercase mb-1">Veli erişimi</div>
      <form data-veli-davet="${esc(s.id)}" class="flex flex-wrap gap-2">
        <input name="email" type="email" required value="${esc(eposta)}"
          placeholder="veli e-postası"
          class="flex-1 min-w-[180px] rounded-lg border border-line px-2.5 py-1.5 text-xs">
        <button type="submit"
          class="rounded-lg bg-grape text-white font-semibold text-xs px-3 py-1.5 hover:opacity-90 transition">
          ${eposta ? "Daveti yenile" : "Davet et"}
        </button>
      </form>
      <p data-veli-davet-durum class="hidden text-[11px] font-semibold mt-1"></p>
      <p class="text-[10px] text-inksoft/80 mt-1 leading-relaxed">
        Veli bu adresle Google veya Apple hesabından girdiğinde yalnızca
        kendi çocuğunun kaydını görür.
      </p>
    </div>`;
}

export function closeModal() {
  const modal = document.getElementById("modal");
  modal.classList.add("hidden");
  modal.classList.remove("flex");
}

